export default {
  api: {
    //Dev
    // url: 'http://localhost/out-caribbean-api/api/',
    url: 'https://tsk.outcaribbean.com/api/',
    key: 'DwPp5xUmtnAtN3dqyfCF'
  },

  googleMaps: {
    apiKey: 'AIzaSyDQkvYb4XEO-VzXwH8z86KibrHQCIHlh4w'
  },

  title: {
    pre: 'OUTCARIBBEAN',
  },
}